import React, { useEffect, useState } from 'react';
import "../assets/CSS/app.css";
import { NavLink, useLocation } from 'react-router-dom';
import { FaBook, FaCaretDown, FaFileImport } from 'react-icons/fa';
import { LuNotebookPen } from "react-icons/lu";
import { BsChatSquareTextFill } from "react-icons/bs";
import { MdDashboardCustomize, MdEditNotifications } from "react-icons/md";
import { IoSettings } from "react-icons/io5";


const Sidebar = ({ isOpen, toggleSidebar, isFormOpen }) => {
  const [dropdowns, setDropdowns] = useState({
    shayarimaster: false,
    vocabularymaster: false,
    festivalmaster: false,

  });

  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleDropdown = (dropdown) => {
    setDropdowns(prev => ({
      ...prev,
      [dropdown]: !prev[dropdown]
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector(".sidebar");
      if (isOpen && !sidebar.contains(event.target)) {
        toggleSidebar();
      }
    };

    if (window.innerWidth <= 900) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleSidebar]);

  return (
    <div className="sidebar" id='primary-fonts'>
      {isOpen && window.innerWidth <= 900 && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleSidebar}
        ></div>
      )}

      <aside
        className={`fixed bg-[--primary-color] text-white top-0 left-0 h-full transition-all duration-300 z-50 ${isOpen ? "w-60 open" : "w-14"
          } ${isFormOpen ? "blur-sm" : ""}`}
      >
        {/* Header */}
        <div className="p-4 flex items-center justify-between ">
          <h1 className="text-xl font-bold truncate">{isOpen ? 'Urdu Ustaad' : 'U'}</h1>
        </div>

        {/* Navigation */}
        <nav>
          <ul className="p-2 space-y-1">

            <NavLink
              to="/admin"
              className={`group flex items-center p-2 space-x-4 hover:bg-[--sidebar-hover-color] rounded ${isActive("/admin") ? "bg-[--secondary-color] text-white" : ""}`}
            >
              <MdDashboardCustomize className={`w-5 h-5 transition duration-200 ${isActive("/admin") ? "text-white" : "group-hover:text-white"}`} />
              {isOpen && (
                <span className={`transition-colors duration-200 ${isActive("/admin") ? "text-white" : "group-hover:text-white"}`}>
                  Dashboard
                </span>
              )}
            </NavLink>

            {/* shayari */}
            <div className="relative">
              <button
                onClick={() => toggleDropdown("shayarimaster")}
                className={`group flex items-center justify-between p-2 w-full hover:bg-[--sidebar-hover-color] rounded ${isActive("/shayars") || isActive("/shayari") || isActive("/importshayari") ? "bg-[--secondary-color]" : ""}`}
              >
                <div className="flex items-center space-x-4">
                  <LuNotebookPen className={`text-xl transition-colors duration-200 ${isActive("/shayars") || isActive("/shayari") || isActive("/importshayari") ? "text-white" : " group-hover:text-white"}`} />
                  {isOpen && (
                    <span className={`transition-colors duration-200 ${isActive("/shayars") || isActive("/shayari") || isActive("/importshayari") ? "text-white" : "group-hover:text-white"}`}>
                      Shaa'irii Master
                    </span>
                  )}
                </div>
                {isOpen && (
                  <FaCaretDown
                    className={`transform transition-transform ${dropdowns["shayarimaster"] ? "rotate-180" : ""} ${isActive("/shayars") || isActive("/shayari") || isActive("/importshayari") ? "text-white" : "group-hover:text-white"}`}
                  />
                )}
              </button>

              {dropdowns["shayarimaster"] && isOpen && (
                <div className="pl-8 mt-2">
                  <NavLink
                    to="shayars"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/shayars") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Shaa'ir
                  </NavLink>
                  <NavLink
                    to="shayari"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/shayari") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Shaa'irii
                  </NavLink>
                  <NavLink
                    to="importshayari"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/importshayari") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Import Shaa'irii
                  </NavLink>
                </div>
              )}



              {/* vocabulary */}
              <button
                onClick={() => toggleDropdown("vocabularymaster")}
                className={`group flex items-center justify-between p-2 w-full hover:bg-[--sidebar-hover-color] rounded ${isActive("/vocabulary") || isActive("/vocabularycategory") || isActive("/importvocabulary") ? "bg-[--secondary-color]" : ""}`}
              >
                <div className="flex items-center space-x-4">
                  <FaBook className={`text-xl transition-colors duration-200 ${isActive("/vocabulary") || isActive("/vocabularycategory") || isActive("/importvocabulary") ? "text-white" : " group-hover:text-white"}`} />
                  {isOpen && (
                    <span className={`transition-colors duration-200 ${isActive("/vocabulary") || isActive("/vocabularycategory") || isActive("/importvocabulary") ? "text-white" : "group-hover:text-white"}`}>
                      Vocabulary Master
                    </span>
                  )}
                </div>
                {isOpen && (
                  <FaCaretDown
                    className={`transform transition-transform ${dropdowns["vocabularymaster"] ? "rotate-180" : ""} ${isActive("/vocabulary") || isActive("/vocabularycategory") || isActive("/importshayari") ? "text-white" : "group-hover:text-white"}`}
                  />
                )}
              </button>
              {dropdowns["vocabularymaster"] && isOpen && (
                <div className="pl-8 mt-2">
                  <NavLink
                    to="vocabulary"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/vocabulary") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Vocabulary
                  </NavLink>
                  <NavLink
                    to="vocabularycategory"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/vocabularycategory") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤  Category
                  </NavLink>
                  <NavLink
                    to="importvocabulary"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/importvocabulary") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Import Vocabulary
                  </NavLink>
                </div>
              )}

              {/* festival */}
              <button
                onClick={() => toggleDropdown("festivalmaster")}
                className={`group flex items-center justify-between p-2 w-full hover:bg-[--sidebar-hover-color] rounded ${isActive("/festival") || isActive("/festivalshayari") || isActive("/importfestivalshayari") ? "bg-[--secondary-color]" : ""}`}
              >
                <div className="flex items-center space-x-4">
                  <LuNotebookPen className={`text-xl transition-colors duration-200 ${isActive("/festival") || isActive("/festivalshayari") || isActive("/importfestivalshayari") ? "text-white" : " group-hover:text-white"}`} />
                  {isOpen && (
                    <span className={`transition-colors duration-200 ${isActive("/festival") || isActive("/festivalshayari") || isActive("/importfestivalshayari") ? "text-white" : "group-hover:text-white"}`}>
                      Festival Master
                    </span>
                  )}
                </div>
                {isOpen && (
                  <FaCaretDown
                    className={`transform transition-transform ${dropdowns["shayarimaster"] ? "rotate-180" : ""} ${isActive("/festival") || isActive("/festivalshayari") || isActive("/importfestivalshayari") ? "text-white" : "group-hover:text-white"}`}
                  />
                )}
              </button>

              {dropdowns["festivalmaster"] && isOpen && (
                <div className="pl-8 mt-2">
                  <NavLink
                    to="festival"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/festival") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Festival
                  </NavLink>
                  <NavLink
                    to="festivalshayari"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/festivalshayari") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Festival Shaa'irii
                  </NavLink>

                  <NavLink
                    to="importfestivalshayari"
                    className={`block p-2 hover:text-[--sidebar-hover-color] rounded ${isActive("/importfestivalshayari") ? "text-[--secondary-color] " : ""}`}
                  >
                    ➤ Import Shaa'irii
                  </NavLink>

                </div>
              )}

              <NavLink
                to="importlesson"
                className={`group flex items-center p-2 space-x-4 hover:bg-[--sidebar-hover-color] rounded ${isActive("/importlesson") ? "bg-[--secondary-color] text-white" : ""}`}
              >
                <FaFileImport className={`w-5 h-5 transition duration-200 ${isActive("/importlesson") ? "text-white" : "group-hover:text-white"}`} />
                {isOpen && (
                  <span className={`transition-colors duration-200 ${isActive("/importlesson") ? "text-white" : "group-hover:text-white"}`}>
                    Import Lesson
                  </span>
                )}
              </NavLink>

              <NavLink
                to="sendnotification"
                className={`group flex items-center p-2 space-x-4 hover:bg-[--sidebar-hover-color] rounded ${isActive("/sendnotification") ? "bg-[--secondary-color] text-white" : ""}`}
              >
                <MdEditNotifications className={`w-5 h-5 transition duration-200 ${isActive("/sendnotification") ? "text-white" : "group-hover:text-white"}`} />
                {isOpen && (
                  <span className={`transition-colors duration-200 ${isActive("/sendnotification") ? "text-white" : "group-hover:text-white"}`}>
                    Send Notification
                  </span>
                )}
              </NavLink>

              <NavLink
                to="userchats"
                className={`group flex items-center p-2 space-x-4 hover:bg-[--sidebar-hover-color] rounded ${isActive("/userchats") ? "bg-[--secondary-color] text-white" : ""}`}
              >
                <BsChatSquareTextFill className={`w-5 h-5 transition duration-200 ${isActive("/userchats") ? "text-white" : "group-hover:text-white"}`} />
                {isOpen && (
                  <span className={`transition-colors duration-200 ${isActive("/userchats") ? "text-white" : "group-hover:text-white"}`}>
                    User Chats
                  </span>
                )}
              </NavLink>


              <NavLink
                to="settings"
                className={`group flex items-center p-2 space-x-4 hover:bg-[--sidebar-hover-color] rounded ${isActive("/settings") ? "bg-[--secondary-color] text-white" : ""}`}
              >
                <IoSettings className={`w-5 h-5 transition duration-200 ${isActive("/settings") ? "text-white" : "group-hover:text-white"}`} />
                {isOpen && (
                  <span className={`transition-colors duration-200 ${isActive("/settings") ? "text-white" : "group-hover:text-white"}`}>
                    Settings
                  </span>
                )}
              </NavLink>

            </div>

          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;

